import { IItemForGetShortInfo, ITotalPrice } from 'types';
import React, { useCallback, useMemo } from 'react';
import MultipleSelect from './components/MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './IsDisabledField.module.scss';

interface IIsDisabledField {
	setDisabledInRestaurants: (value: string[]) => void;
	isDisabledInRestaurants: string[];
	totalPrices: ITotalPrice[];
	fetchedRestaurants: IItemForGetShortInfo[];
}

const IsDisabledField: React.FC<IIsDisabledField> = ({
	isDisabledInRestaurants,
	totalPrices,
	setDisabledInRestaurants,
	fetchedRestaurants,
}) => {
	const handleRemove = useCallback(
		(id: string) => {
			const updatedSelectedItems = isDisabledInRestaurants.filter((el) => el !== id);
			setDisabledInRestaurants(updatedSelectedItems);
		},
		[isDisabledInRestaurants, setDisabledInRestaurants],
	);

	const restaurantsList = useMemo(() => {
		return isDisabledInRestaurants.map((el) => {
			const label = fetchedRestaurants.find((rest) => rest.id === el)?.name || '';
			return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
		});
	}, [fetchedRestaurants, isDisabledInRestaurants]);

	return (
		<div className={style.container} data-test="IsDisabledField">
			<div className={style.field}>
				<MultipleSelect
					isDisabledInRestaurants={isDisabledInRestaurants}
					totalPrices={totalPrices}
					setDisabledInRestaurants={setDisabledInRestaurants}
				/>
			</div>
			<div className={style.groupsList}>{restaurantsList}</div>
		</div>
	);
};

export default React.memo(IsDisabledField);
